import React from "react"

import TriagePatients from "../components/RPMCriticalInitialScreen/Triage/TriagePatients"

const TriageInitialScreen = () => <TriagePatients />

export default TriageInitialScreen